import { useState } from "react";
import { Flex, App, Result } from "antd";
import CustomButton from "../../../components/CustomButton/Button";
import { useSelector, useDispatch } from "react-redux";
import {
  getDealsByStatus,
  updateDealInterestStatus,
} from "../../../redux/slices/DealSlice";
import CustomModal from "../../../components/CustomModal/CustomModal";
import ActionReasonModal from "../../../components/ActionReasonModal/ActionReasonModal";
import { BTN_TXT } from "../../../constants/constants";

const JvDealBuyButtons = ({
  options = [],
  dealId,
  fromDealsCard,
  intrestModal,
  setIntrestModal,
}) => {
  const { message } = App.useApp();
  const dispatch = useDispatch();
  const { interestStatusLoading, interestStatusError } = useSelector(
    (state) => state.deal,
  );
  const [clickedOption, setClickedOption] = useState(null);
  const [reasonModal, setReasonModal] = useState(false);

  const onAction = async (option) => {
    if (option === "Not Interested") {
      setReasonModal(true);
      return;
    }

    setClickedOption(option);

    try {
      const res = await dispatch(
        updateDealInterestStatus({
          dealId,
          interestStatus: option,
        }),
      );

      if (
        updateDealInterestStatus.fulfilled.match(res) &&
        res?.payload?.statusCode === 201
      ) {
        const successMsg =
          option === "Neutral" || option === "Interested"
            ? "Interest recorded successfully."
            : "Request for more info submitted successfully.";
        message.success(successMsg);

        if (
          option === "Neutral" ||
          option === "Interested" ||
          option === "Request more info"
        ) {
          setIntrestModal({
            open: true,
            option,
          });
        }
      } else {
        const errorMsg =
          (typeof res?.payload === "string" && res.payload) ||
          res?.payload?.message ||
          res?.payload?.error ||
          "Failed to update interest status. Please try again.";
        message.error(errorMsg);
      }
    } catch {
      message.error("Failed to update interest status. Please try again.");
    } finally {
      setClickedOption(null);
    }
  };

  const handleSubmitFeedback = async (values) => {
    const res = await dispatch(
      updateDealInterestStatus({
        dealId,
        interestStatus: "Not Interested",
        feedback: values.reason,
      }),
    );

    if (
      updateDealInterestStatus.fulfilled.match(res) &&
      res?.payload?.statusCode === 201
    ) {
      dispatch(getDealsByStatus({ status: "approved" }));
      setReasonModal(false);
      message.success("Your feedback has been submitted.");
    } else {
      const errorMsg =
        (typeof res?.payload === "string" && res.payload) ||
        res?.payload?.message ||
        res?.payload?.error ||
        "Failed to submit feedback. Please try again.";
      message.error(errorMsg);
    }
  };

  return (
    <div className="jv-deal-buy-buttons">
      <Flex gap={12} wrap>
        {options.map((option) => (
          <CustomButton
            key={option}
            block
            loading={clickedOption === option && interestStatusLoading}
            disabled={interestStatusLoading && clickedOption !== option}
            className={`action-btn ${option
              .toLowerCase()
              .replace(/\s+/g, "-")}`}
            onClick={() => onAction(option)}
          >
            {option}
          </CustomButton>
        ))}
      </Flex>

      <CustomModal
        open={intrestModal.open}
        footer={null}
        centered
        closable={false}
        onCancel={() =>
          setIntrestModal({
            open: false,
            option: "",
          })
        }
        content={
          <Result
            status="success"
            title={
              intrestModal.option === "Neutral" ||
              intrestModal.option === "Interested"
                ? "Thank you for your interest!"
                : "Thank you for reaching out!"
            }
            subTitle={
              intrestModal.option === "Neutral" ||
              intrestModal.option === "Interested"
                ? "Your interest has been recorded. Our team will get in touch with you if there are any updates regarding this opportunity."
                : "We've received your request for additional information. Our team will contact you shortly with the details you need."
            }
            extra={[
              <CustomButton
                key="ok"
                type="primary"
                onClick={() =>
                  setIntrestModal({
                    open: false,
                    option: "",
                  })
                }
              >
                OK
              </CustomButton>,
            ]}
          />
        }
      />
      {reasonModal && (
        <ActionReasonModal
          title="Reason for Not Interest"
          label="Please provide feedback"
          btnName={BTN_TXT.SUBMIT}
          onClose={() => setReasonModal(false)}
          onSubmit={handleSubmitFeedback}
          submitLoading={interestStatusLoading}
          submitError={interestStatusError}
        />
      )}
    </div>
  );
};

export default JvDealBuyButtons;
